import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilter = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 1.5,
			y: 3.47221,
			width: 13,
			height: 1,
			rx: .5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3.5,
			y: 7.43443,
			width: 9,
			height: 1.07563,
			rx: .537815,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 5.25,
			y: 11.4167,
			width: 5.5,
			height: 1.11111,
			rx: .555556,
			fill: "currentColor"
		})
	]
});
export default SvgFilter;
